import {
  FilterDisclosure,
  FilterFooter,
  FilterListbox,
  FilterOptionRadio,
  FilterPopover,
} from '@vtex/admin-ui'
import { defineMessages, useIntl } from 'react-intl'
import type { SimplifiedPromotion } from 'typings'
import { usePromotionsFilterState } from '../useFiltersState'

const messages = defineMessages({
  utm: { id: 'admin/promotions.filters.utm' },
  withUtm: { id: 'admin/promotions.filters.utm.true' },
  withoutUtm: { id: 'admin/promotions.filters.utm.false' },
})

function filterByUtm(
  promotion: SimplifiedPromotion,
  selectedOption: string | undefined
) {
  return (
    selectedOption === undefined ||
    (selectedOption === 'contains') ===
      (Boolean(promotion.utmSource.length) ||
        Boolean(promotion.utmCampaign.length))
  )
}

export function FilterByUTM() {
  const { formatMessage } = useIntl()

  const state = usePromotionsFilterState({
    id: 'utm',
    filterFn: (item) => filterByUtm(item, state.appliedItem?.id),
  })

  return (
    <>
      <FilterDisclosure state={state}>
        {formatMessage(messages.utm)}
      </FilterDisclosure>
      <FilterPopover state={state}>
        <FilterListbox>
          <FilterOptionRadio
            id="contains"
            label={formatMessage(messages.withUtm)}
          />
          <FilterOptionRadio
            id="not-contains"
            label={formatMessage(messages.withoutUtm)}
          />
        </FilterListbox>
        <FilterFooter />
      </FilterPopover>
    </>
  )
}
